// HTTP status codes the app branches on by hand. httpClient and vaiClient
// handle the common ones centrally; these are for the local catches.
export const HTTP_STATUS_BAD_REQUEST = 400
export const HTTP_STATUS_UNAUTHORIZED = 401
export const HTTP_STATUS_GONE = 410
export const HTTP_STATUS_UNPROCESSABLE_ENTITY = 422
export const HTTP_STATUS_FAILED_DEPENDENCY = 424
